<template>
    <div>
        <!--  <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Add Management Users</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                 <v-col cols="3" sm="3" md="3">
                    <v-autocomplete rounded @change="getOrgData()" :items="org_list" label="Organization" item-text="name" item-value="id" outlined dense v-model="org"></v-autocomplete>
                </v-col>
            </v-row>
        </v-card> -->
          <v-card class="box" v-if="management_users!=''">
            <v-data-table  :headers="headers" :items="management_users" >
                <template v-slot:top>
                    <v-toolbar flat class="toolbar">
                        <v-toolbar-title>Schools Bypass Login</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical ></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.login`]="{ item }">
                    <v-btn class="ma-2" rounded color="orange" :loading="loader" @click="bypasslogin(item)">Login</v-btn>
                </template>
            </v-data-table>
 </v-card>
    </div>
</template>
<script>
    import Header from "../shared/UpdatedHeader.vue";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
         components: { Header },
        data: () => ({
            selected_children: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: false,
            current_ay: "",
            search: "",
            s3url: "",
            org_list: [],org:"",management_users:[],
             headers:[
                { text: "Organization", value: "org_name" },
                { text: "Instructor", value: "instructor" },
                { text: "Login", value: "login" },
                ],
        }),
        methods: {
             bypasslogin(item) {
                if (item.inst_user == null || item.inst_user == "") {
                    this.showSnackbar("#b71c1c", "Please enter username...!");
                    return false;
                } else {
                    const formData = {
                    username: item.inst_user,
                    from:"Management"
                    };
        this.login_loader = true;
        localStorage.setItem("is_school_bypass_login", true);
        axios
          .post("/management/bypass", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar("#4caf50", res.data.snackbar);
              localStorage.setItem("EPS-token", res.data.bypass_token);
              localStorage.setItem("EPS-tenant", res.data.bypass_tenant);
              localStorage.setItem("EPS-uid", res.data.bypass_uid);
              localStorage.setItem("EPS-ut", res.data.bypass_ut);
              localStorage.setItem("EPS-bypassed-by",res.data.bypassed_by);

              localStorage.setItem("username", res.data.username)
              localStorage.setItem("profile_image_path", res.data.profile_image_path)
              localStorage.setItem("profile_image_name", res.data.profile_image_name)
              
              localStorage.setItem(
                "report-field",
                JSON.stringify(res.data.bypass_rep_fields)
              );
              this.$session.start();
              this.$router.push("/home");
            } else {
              this.showSnackbar("#b71c1c", res.data.snackbar);
            }
            this.login_loader = false;
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            this.login_loader = false;
            window.console.log(error);
          });
      }
    },
            getOrgData(){
                this.users_list=[],this.instructor_list=[]
                 const formData = {
                    org: this.org,
                };
                this.loader=true
                axios
                    .post("Management/getOrgData", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.users_list=res.data.users_list
                            this.instructor_list=res.data.instructor_list,
                            this.management_users=res.data.management_user_list
                            if(this.management_users=='' || this.management_users.length==0){
                                this.showSnackbar("#b71c1c", "No Records Found...");
                            }
                        }
                        if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("Management/getManagementUsers")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.org_list = res.data.org_list)
                            this.management_users=res.data.management_user_list
                            if(this.management_users=='' || this.management_users.length==0){
                                this.showSnackbar("#b71c1c", "No Records Found...");
                            }
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
        },

        mounted() {
             this.onload();
            this.org_id = localStorage.getItem("EPS-tenant");
            // datePickerId.min = new Date().toISOString().split("T")[0];
        },
    };
</script>

<style scoped>
  .select {
      width: 100%;
      display: inline-block;
      border: 1px solid black;
      border-radius: 4px;
      box-sizing: border-box;
  }
input[type="text"] {
      width: 100%;
      display: inline-block;
      border: 1px solid black;
      border-radius: 4px;
      box-sizing: border-box;
  }
input[type=number] {
  width: 50%;
  display: inline-block;
  border: 1px solid black;
  border-radius: 4px;
  box-sizing: border-box;
}

    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .datepicker-div {
        margin-top: none !important;
    }
    .datepicker-div label {
        color: #00000099;
        font-size: 12px;
        position: relative;
    }
     input[type="date"] {
      width: 100%;
      display: inline-block;
      padding: 0.3rem;
      border: 1px solid gray;
      border-radius: 30px;
      box-sizing: border-box;
      padding-top: none !important;
      margin-top: none !important;
  }
</style>
